import { FontDescriptor } from '@/utils'
import shuffle from 'lodash/shuffle'

export const generateRandomOrder = (fonts: FontDescriptor[]) => {
  return shuffle(fonts.map((_, i) => i))
}
